module.exports = __webpack_public_path__ + "img/cadastro-automoveis.808fc22c.jpg";